export default function ReviewsSection() {
  const reviews = [
    {
      id: 1,
      name: 'Sarah Mitchell',
      location: 'Bellevue, WA',
      rating: 5,
      text: 'Terra Landscape transformed our backyard into an absolute paradise! The 3D renderings helped us visualize everything perfectly before construction. The team was professional, punctual, and the quality exceeded our expectations.',
      project: 'Complete Backyard Renovation'
    },
    {
      id: 2,
      name: 'Michael Chen',
      location: 'Seattle, WA',
      rating: 5,
      text: 'Outstanding work on our retaining walls and patio installation. The attention to detail and craftsmanship is remarkable. They completed the project on time and within budget. Highly recommend!',
      project: 'Retaining Walls & Patio'
    },
    {
      id: 3,
      name: 'Jennifer Rodriguez',
      location: 'Kirkland, WA',
      rating: 5,
      text: 'The artificial turf installation looks incredibly natural and has been maintenance-free for over a year. The drainage system works perfectly, and our kids love playing on it year-round.',
      project: 'Artificial Turf Installation'
    },
    {
      id: 4,
      name: 'David Thompson',
      location: 'Redmond, WA',
      rating: 5,
      text: 'From initial consultation to project completion, Terra Landscape was exceptional. The 3D visualization made decision-making easy, and the final result surpassed our dreams. True professionals!',
      project: 'Outdoor Living Space'
    },
    {
      id: 5,
      name: 'Lisa Park',
      location: 'Bothell, WA',
      rating: 5,
      text: 'The landscape lighting they installed has completely transformed our property. The design is both functional and beautiful, providing perfect ambiance for evening entertaining.',
      project: 'Landscape Lighting'
    },
    {
      id: 6,
      name: 'Robert Johnson',
      location: 'Sammamish, WA',
      rating: 5,
      text: 'Excellent communication throughout the entire process. The team was knowledgeable, respectful of our property, and delivered exactly what was promised. Couldn\'t be happier with our new outdoor space.',
      project: 'Complete Landscape Design'
    }
  ];

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i 
        key={index}
        className={`ri-star-${index < rating ? 'fill' : 'line'} text-yellow-400`}
      ></i>
    ));
  };

  const getInitials = (name: string) => {
    return name.split(' ').map(word => word[0]).join('').toUpperCase();
  };

  const getAvatarColor = (index: number) => {
    const colors = [
      'bg-blue-500',
      'bg-green-500', 
      'bg-purple-500',
      'bg-orange-500',
      'bg-pink-500',
      'bg-indigo-500'
    ];
    return colors[index % colors.length];
  };

  return (
    <section id="reviews" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1C1C1C] mb-6 font-['Playfair_Display']">
            What Our Clients Say
          </h2>
          <p className="text-xl text-[#1C1C1C]/70 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our satisfied clients have to say about 
            their experience with Terra Construction.
          </p>
        </div>

        {/* Reviews grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {reviews.map((review, index) => (
            <div 
              key={review.id}
              className="bg-[#F5F5F5] rounded-xl p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* Rating */}
              <div className="flex items-center mb-4">
                {renderStars(review.rating)}
              </div>

              {/* Review text */}
              <p className="text-[#1C1C1C]/80 mb-6 leading-relaxed italic">
                "{review.text}"
              </p>

              {/* Client info */}
              <div className="flex items-center">
                <div className={`w-12 h-12 rounded-full ${getAvatarColor(index)} flex items-center justify-center mr-4`}>
                  <span className="text-white font-semibold text-sm">
                    {getInitials(review.name)}
                  </span>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1C1C1C]">{review.name}</h4>
                  <p className="text-sm text-[#1C1C1C]/60">{review.location}</p>
                  <p className="text-sm text-[#4B6043] font-medium">{review.project}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Overall rating summary */}
        <div className="bg-[#4B6043] rounded-2xl p-8 text-center text-white">
          <div className="flex items-center justify-center mb-4">
            <div className="text-5xl font-bold mr-4">4.9</div>
            <div>
              <div className="flex items-center mb-2">
                {renderStars(5)}
              </div>
              <p className="text-white/80">On our reviews</p>
            </div>
          </div>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Join our satisfied homeowners who have transformed their outdoor spaces with Terra Construction.
          </p>
        </div>
      </div>
    </section>
  );
}
